<template>
	<HeaderBar service-title="Pharmacies de garde" />
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	@Component
	export default class AppHeader extends Vue {}
</script>

<style lang="scss" scoped>
	@import '@cnamts/design-tokens/dist/tokens';

	.vd-header-bar-container :deep() {
		.vd-header-bar {
			z-index: 2;
		}

		.vd-header-home-link + svg[role="img"] {
			fill: $vd-green-darken-20;
		}

		.vd-header-title {
			font-family: 'Roboto', sans-serif !important;
			font-weight: 600 !important;
			line-height: 1 !important;
			color: $vd-green-darken-20 !important;
			font-size: 2rem !important;
			@media only screen and (max-width: 959px) {
				font-size: 0.875rem !important;
				font-weight: 700 !important;
			}
		}
	}
</style>
